import { render, staticRenderFns } from "./PosBadgeImport.vue?vue&type=template&id=2ef9f30a&scoped=true"
import script from "./PosBadgeImport.vue?vue&type=script&lang=js"
export * from "./PosBadgeImport.vue?vue&type=script&lang=js"
import style0 from "./PosBadgeImport.vue?vue&type=style&index=0&id=2ef9f30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9f30a",
  null
  
)

export default component.exports